import { useTranslation } from "react-i18next";

import { IconButton } from "@molecules";

type HaNDetailsHeaderProps = {
  title: string;
  onBack?: () => void;
  onClose: () => void;
};

// The title between back and close. The side columns keep their width without a back button, so the title stays centred.
export const HaNDetailsHeader = ({ title, onBack, onClose }: HaNDetailsHeaderProps) => {
  const { t } = useTranslation();

  return (
    <header className="grid w-full flex-none grid-cols-[2rem_1fr_2rem] items-center gap-x-2 border-b px-5 py-6">
      <div>
        {onBack && (
          <IconButton
            size="small"
            aria-label={t("workplace:GoBack")}
            iconButton="tertiary"
            icon="caretLeft"
            onClick={onBack}
          />
        )}
      </div>

      <h2 className="truncate text-center text-[15px] font-semibold leading-5">{title}</h2>

      <IconButton
        size="small"
        aria-label={t("translation:Close")}
        iconButton="tertiary"
        icon="close"
        onClick={onClose}
      />
    </header>
  );
};
